export const GOOGLE_MAPS_OVERLAY_STYLE = {
  fillColor: '#7857F2',
  fillOpacity: '0.1',
  strokeColor: '#7857F2',
  strokeWeight: 2,
};

export const GOOGLE_MAPS_CENTER = { lat: 52.18912830978376, lng: 19.298177933029503 };
